<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.baixa.history"
            :request-params="requestParams"
            :tbody-tr-class="rowClass"
            class="table-baixas"
            sort-by="data"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="$refs.ModalDetalhes.open(item)"
                    color="outline-primary"
                    small
                    title="Exibir detalhes"
                >
                    <rkm-icon icon="align-justify" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.estornado"
                    @click.stop="print(item)"
                    color="primary"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.estornado"
                    :title="!!item.estornado ? 'Estornado' : 'Estornar'"
                    @click="handleEstorno(item)"
                    color="danger"
                    small
                >
                    <rkm-icon icon="undo-alt" />
                </rkm-button>
            </template>

            <template #afterPagination>
                <div class="mt-2">
                    <rkm-row>
                        <rkm-col>
                            <p>A linha em <span class="red">vermelho</span> representa uma baixa que foi estornada.</p>
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-data-table>

        <ModalDetalhes ref="ModalDetalhes" />
    </div>
</template>

<script>
// Components.
import ModalDetalhes from './components/detalhe/Modal'

import moment from 'moment'
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, file } from '@/mixins'

export default {
    components: { ModalDetalhes },
    computed: {
        requestParams() {

            return { material_id: this.material.id }
        },
        fields() {

            return [
                {
                    name: 'almoxarifadoSaida.createdAt',
                    key: 'data',
                    label: 'Data',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'almoxarifadoMotivoBaixa.descricao',
                    key: 'motivoDescricao',
                    label: 'Motivo',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroCidadao.nome',
                    key: 'usuarioSolicitanteNome',
                    label: 'Usuário solicitante',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'quantidade',
                    key: 'quantidade',
                    label: 'Quantidade',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    created() {

        this.repositories = {
            baixa: this.getConectaSusRepository('almoxarifado.baixa'),
            balancete: this.getConectaSusRepository('almoxarifado.balancete'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print({ saidaItemId }) {

            this.setLoading()

            return this.repositories.impressao.baixa(saidaItemId)
                .then(response => {

                    this.openFile(response.data, response.headers['content-type'])
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEstorno(item) {

            const data = moment(item.data, 'DD/MM/YYYY').format('YYYY-MM-DD')

            this.setLoading()

            this.repositories.balancete.checkDate(data)
                .then(({ data }) => {

                    if (!data.mesFechado) {

                        this.showDeleteConfirmation(
                            'Deseja realmente estornar a baixa?',
                            () => this.repositories.baixa.reverse(item.saidaItemId)
                                .then(() => item.estornado = true),
                            this.handleError
                        )

                        return
                    }

                    this.showValidationNotification(
                        'A data da baixa corresponde a um mês já finalizado. Estorno não permitido.'
                    )
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        rowClass(item, type) {

            if (type === 'row' && item && !!item.estornado) {

                return 'table-danger'
            }
        }
    },
    mixins: [ repository, error, file ],
    props: {
        material: { type: Object, required: true }
    }
}
</script>

<style scoped>
.table-baixas >>> .red { color: red; }
</style>